import React from 'react'
import * as S from '../../styles'

export const SecondRowWidgetsWide = (props) => {
  const notificationsAccessState = props.notificationsAccessState
  const devicesAccessState = props.devicesAccessState
  const devicePolicyAccessState = props.devicePolicyAccessState
  const usersAccessState = props.usersAccessState
  const endPtSecurityAccessState = props.endPtSecurityAccessState

  const renderSecureFleetWidget = props.renderSecureFleetWidget
  const renderSolutionsWidget = props.renderSolutionsWidget

  const displaySolutionsWidget = () => {
    if (
      (notificationsAccessState &&
        !devicesAccessState &&
        devicePolicyAccessState &&
        usersAccessState &&
        endPtSecurityAccessState) ||
      (!notificationsAccessState &&
        devicesAccessState &&
        devicePolicyAccessState &&
        usersAccessState &&
        endPtSecurityAccessState) ||
      (notificationsAccessState &&
        devicesAccessState &&
        !devicePolicyAccessState &&
        !usersAccessState &&
        endPtSecurityAccessState)
    ) {
      return (
        <S.Grid
          leftChildFrWidth={4}
          middleChildFrWidth={4}
          rightChildFrWidth={4}
        >
          {renderSolutionsWidget}
          <S.EmptyDiv />
          <S.EmptyDiv />
        </S.Grid>
      )
    }
  }

  const displayEmptyDiv = () => {
    if (
      (!notificationsAccessState &&
        !devicesAccessState &&
        !devicePolicyAccessState &&
        !usersAccessState) ||
      (notificationsAccessState &&
        !devicesAccessState &&
        !devicePolicyAccessState &&
        !usersAccessState &&
        !endPtSecurityAccessState) ||
      (!notificationsAccessState &&
        devicesAccessState &&
        !devicePolicyAccessState &&
        !usersAccessState &&
        !endPtSecurityAccessState) ||
      (!notificationsAccessState &&
        !devicesAccessState &&
        devicePolicyAccessState &&
        usersAccessState &&
        !endPtSecurityAccessState) ||
      (!notificationsAccessState &&
        !devicesAccessState &&
        devicePolicyAccessState &&
        !usersAccessState &&
        !endPtSecurityAccessState) ||
      (notificationsAccessState &&
        !devicesAccessState &&
        !devicePolicyAccessState &&
        usersAccessState &&
        !endPtSecurityAccessState) ||
      (notificationsAccessState &&
        !devicesAccessState &&
        devicePolicyAccessState &&
        !usersAccessState &&
        !endPtSecurityAccessState) ||
      (notificationsAccessState &&
        !devicesAccessState &&
        !devicePolicyAccessState &&
        usersAccessState &&
        !endPtSecurityAccessState) ||
      (!notificationsAccessState &&
        devicesAccessState &&
        devicePolicyAccessState &&
        !usersAccessState &&
        !endPtSecurityAccessState) ||
      (!notificationsAccessState &&
        devicesAccessState &&
        !devicePolicyAccessState &&
        usersAccessState &&
        !endPtSecurityAccessState) ||
      (!notificationsAccessState &&
        !devicesAccessState &&
        devicePolicyAccessState &&
        !usersAccessState &&
        endPtSecurityAccessState) ||
      (!notificationsAccessState &&
        !devicesAccessState &&
        !devicePolicyAccessState &&
        usersAccessState &&
        endPtSecurityAccessState) ||
      (!notificationsAccessState &&
        devicesAccessState &&
        !devicePolicyAccessState &&
        usersAccessState &&
        endPtSecurityAccessState) ||
      (!notificationsAccessState &&
        devicesAccessState &&
        devicePolicyAccessState &&
        !usersAccessState &&
        endPtSecurityAccessState) ||
      (notificationsAccessState &&
        !devicesAccessState &&
        devicePolicyAccessState &&
        !usersAccessState &&
        endPtSecurityAccessState) ||
      (notificationsAccessState &&
        !devicesAccessState &&
        !devicePolicyAccessState &&
        usersAccessState &&
        endPtSecurityAccessState) ||
      (!notificationsAccessState &&
        !devicesAccessState &&
        devicePolicyAccessState &&
        usersAccessState &&
        endPtSecurityAccessState)
    ) {
      return <></>
    }
  }

  if (
    (notificationsAccessState &&
      devicesAccessState &&
      devicePolicyAccessState &&
      usersAccessState &&
      endPtSecurityAccessState) ||
    (notificationsAccessState &&
      devicesAccessState &&
      !devicePolicyAccessState &&
      usersAccessState &&
      endPtSecurityAccessState) ||
    (notificationsAccessState &&
      devicesAccessState &&
      devicePolicyAccessState &&
      !usersAccessState &&
      endPtSecurityAccessState)
  ) {
    return (
      <S.Grid
        leftChildFrWidth={8}
        rightChildFrWidth={4}
      >
        {renderSecureFleetWidget}
        {renderSolutionsWidget}
      </S.Grid>
    )
  }

  return (
    <>
      {displaySolutionsWidget()}

      {displayEmptyDiv()}
    </>
  )
}

export default SecondRowWidgetsWide
